export enum SumInsured {
    BuildingPlanLanded = 400000,
    BuildingPlanNonLanded = 200000,
    ContentPlanLanded = 90000,
    ContentPlanNonLanded = 100000,
    BuildingContentPlanBuildingLanded = 500000,
    BuildingContentPlanContentLanded = 60000,
    BuildingContentPlanBuildingNonLanded = 350000,
    BuildingContentPlanContentNonLanded = 40000,
    LppsaPlanA = 20_000,
    LppsaPlanB = 30_000,
}